<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-import"
      scrollable
      centered
      title="Adicionar anexo"
      button-size="sm"
    >
      <div class="form-group row">
        <div class="col-md-12 pt-2">
          <label for="txtData"> Anexo:</label>
          <div class="input-group" @drop="onUploadDrop" @dragover="onUploadDragover">
            <div class="upload" style="cursor: pointer;" @click="onUploadClick">
              <input
                multiple
                type="file"
                ref="inputFile"
                v-show="false"
                accept="*"
                @change="onFileChange"
              />
              <div><i class="fas fa-file-import" style="font-size: 17px"></i></div>
              <span v-if="!attach">Clique ou arraste aqui para anexar!</span>
              <span v-else>
                <span v-for="(upload, index) in attach" :key="index">{{ upload.name }} &nbsp;</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-third btn-sm" v-on:click="onCreate" v-b-tooltip.hover :title="'Importar'"><i class="fas fa-check-circle"></i><span class="d-md-down-none"> Importar</span></button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import AttachmentRepository from '@/shared/http/repositories/configurations/attachment.js'

export default {
  name: 'AttachmentModal',
  mixins: [ActionsForm],
  data () {
    return {
      attach: null,
      files: []
    }
  },
  methods: {
    showModal () {
      this.onClear()
      this.$refs['modal-import'].show()
    },
    hideModal () {
      this.$refs['modal-import'].hide()
    },
    onClear () {
      this.attach = null
      this.files = []
    },
    onUploadDragover (event) {
      event.preventDefault()
    },
    onUploadDrop (event) {
      event.preventDefault()
      let files = event.dataTransfer.files
      this.attach = files
      if (files && files.length > 0) {
        for (var i in files) {
          if (files[i].size > 0) {
            this.files.push(files[i])
          }
        }
      }
    },
    onUploadClick () {
      this.$refs.inputFile.click()
    },
    onFileChange (event) {
      event.preventDefault()
      let files = event.target.files
      this.attach = files
      if (files && files.length > 0) {
        for (var i in files) {
          if (files[i].size > 0) {
            this.files.push(files[i])
          }
        }
      }
    },
    onCreate () {
      loading.push()

      var formData = new FormData()
      if (this.files && this.files.length > 0) {
        for (let file of this.files) {
          formData.append('file', file)
        }
      }

      AttachmentRepository.Create(formData)
        .then((response) => {
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.onClear()
            this.hideModal()
            this.$emit('Back')
            loading.pop()
          }
        })
        .catch(this.onExceptionWithErrorMessage)
    }
  }
}
</script>

<style scoped>
  .upload {
    border: solid 1px #ccc;
    border-radius: 4px;
    background-color: #efefef;
    padding: 3%;
    width: 100%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/attachments/components/modal/importmodal.vue